import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { AuthContext } from '../App';

const regioni = ['Abruzzo','Basilicata','Calabria','Campania','Emilia-Romagna','Friuli Venezia Giulia','Lazio','Liguria','Lombardia','Marche','Molise','Piemonte','Puglia','Sardegna','Sicilia','Toscana','Trentino-Alto Adige','Umbria','Valle d\'Aosta','Veneto'];
const settori = ['Manifatturiero','Edilizia','Tecnologia','Servizi','Commercio','Turismo','Agricoltura','Artigianato','Energia','Trasporti','Sanita','Alimentare','Altro'];

export default function RegisterPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '', password: '', nome: '', cognome: '', azienda: '', piva: '',
    telefono: '', regione: '', settore: '', fatturato: '', dipendenti: ''
  });
  const [consensoPrivacy, setConsensoPrivacy] = useState(false);
  const [consensoWhatsApp, setConsensoWhatsApp] = useState(false);
  const [consensoNewsletter, setConsensoNewsletter] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) { toast.error('Email e password obbligatori'); return; }
    if (form.password.length < 6) { toast.error('Password minimo 6 caratteri'); return; }
    if (!form.telefono || form.telefono.replace(/\s/g, '').length < 8) {
      toast.error('Numero WhatsApp obbligatorio'); return;
    }
    if (!consensoPrivacy) {
      toast.error('Devi accettare la Privacy Policy per registrarti'); return;
    }
    if (!consensoWhatsApp) {
      toast.error('Devi acconsentire alle comunicazioni WhatsApp per registrarti'); return;
    }
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/register', {
        ...form,
        consenso_privacy: consensoPrivacy,
        consenso_whatsapp: consensoWhatsApp,
        consenso_newsletter: consensoNewsletter
      });
      login(res.data.token, res.data.user);
      toast.success('Registrazione completata! Benvenuto.');
      navigate('/profile');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore registrazione');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page fade-in">
      <div className="auth-card" style={{ maxWidth: 560 }}>
        <h2>Registrati Gratis</h2>
        <p className="subtitle">Crea il tuo account e scopri gli incentivi per la tua azienda</p>
        <form onSubmit={handleSubmit}>
          <div className="grid-2">
            <div className="form-group">
              <label>Nome</label>
              <input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} placeholder="Mario" />
            </div>
            <div className="form-group">
              <label>Cognome</label>
              <input value={form.cognome} onChange={e => setForm({...form, cognome: e.target.value})} placeholder="Rossi" />
            </div>
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@azienda.it" required />
          </div>
          <div className="form-group">
            <label>Password *</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Minimo 6 caratteri" required />
          </div>
          <div className="form-group">
            <label>Numero WhatsApp *</label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 18 }}>📱</span>
              <input
                type="tel"
                value={form.telefono}
                onChange={e => setForm({...form, telefono: e.target.value})}
                placeholder="+39 348 123 4567"
                required
                style={{ paddingLeft: 40 }}
              />
            </div>
            <small style={{ color: '#6b7280', fontSize: 12 }}>Inserisci il numero WhatsApp per ricevere aggiornamenti sugli incentivi</small>
          </div>
          <div className="grid-2">
            <div className="form-group">
              <label>Azienda</label>
              <input value={form.azienda} onChange={e => setForm({...form, azienda: e.target.value})} placeholder="Nome azienda" />
            </div>
            <div className="form-group">
              <label>P.IVA</label>
              <input value={form.piva} onChange={e => setForm({...form, piva: e.target.value})} placeholder="01234567890" />
            </div>
          </div>
          <div className="grid-2">
            <div className="form-group">
              <label>Regione</label>
              <select value={form.regione} onChange={e => setForm({...form, regione: e.target.value})}>
                <option value="">Seleziona...</option>
                {regioni.map(r => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Settore</label>
              <select value={form.settore} onChange={e => setForm({...form, settore: e.target.value})}>
                <option value="">Seleziona...</option>
                {settori.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div className="grid-2">
            <div className="form-group">
              <label>Fatturato Annuo</label>
              <select value={form.fatturato} onChange={e => setForm({...form, fatturato: e.target.value})}>
                <option value="">Seleziona...</option>
                <option value="0-100k">Fino a €100.000</option>
                <option value="100k-500k">€100.000 - €500.000</option>
                <option value="500k-2M">€500.000 - €2.000.000</option>
                <option value="2M-10M">€2.000.000 - €10.000.000</option>
                <option value="10M+">Oltre €10.000.000</option>
              </select>
            </div>
            <div className="form-group">
              <label>Dipendenti</label>
              <select value={form.dipendenti} onChange={e => setForm({...form, dipendenti: e.target.value})}>
                <option value="">Seleziona...</option>
                <option value="1-9">1-9</option>
                <option value="10-49">10-49</option>
                <option value="50-249">50-249</option>
                <option value="250+">250+</option>
              </select>
            </div>
          </div>

          {/* Consenso Privacy Policy */}
          <div style={{ margin: '16px 0 8px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input
              type="checkbox"
              id="consensoPrivacy"
              checked={consensoPrivacy}
              onChange={e => setConsensoPrivacy(e.target.checked)}
              style={{ marginTop: 4, minWidth: 18, minHeight: 18, cursor: 'pointer' }}
            />
            <label htmlFor="consensoPrivacy" style={{ fontSize: 13, color: '#374151', cursor: 'pointer', lineHeight: 1.5 }}>
              Ho letto e accetto la <Link to="/privacy-policy" target="_blank" style={{ color: '#1a56db', textDecoration: 'underline' }}>Privacy Policy</Link> e i <Link to="/termini-e-condizioni" target="_blank" style={{ color: '#1a56db', textDecoration: 'underline' }}>Termini e Condizioni</Link> del servizio. *
            </label>
          </div>

          {/* Consenso Comunicazioni WhatsApp */}
          <div style={{ margin: '8px 0 8px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input
              type="checkbox"
              id="consensoWhatsApp"
              checked={consensoWhatsApp}
              onChange={e => setConsensoWhatsApp(e.target.checked)}
              style={{ marginTop: 4, minWidth: 18, minHeight: 18, cursor: 'pointer' }}
            />
            <label htmlFor="consensoWhatsApp" style={{ fontSize: 13, color: '#374151', cursor: 'pointer', lineHeight: 1.5 }}>
              Acconsento a ricevere comunicazioni, aggiornamenti sugli incentivi e offerte tramite WhatsApp al numero indicato. *
            </label>
          </div>

          {/* Consenso Newsletter e Comunicazioni Commerciali */}
          <div style={{ margin: '8px 0 20px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input
              type="checkbox"
              id="consensoNewsletter"
              checked={consensoNewsletter}
              onChange={e => setConsensoNewsletter(e.target.checked)}
              style={{ marginTop: 4, minWidth: 18, minHeight: 18, cursor: 'pointer' }}
            />
            <label htmlFor="consensoNewsletter" style={{ fontSize: 13, color: '#374151', cursor: 'pointer', lineHeight: 1.5 }}>
              Acconsento a ricevere newsletter e comunicazioni commerciali via email da VerificaIncentivi.it. (Facoltativo — puoi disiscriverti in qualsiasi momento)
            </label>
          </div>

          <button type="submit" className="btn btn-green btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Registrazione...' : 'Registrati Gratis'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6b7280' }}>
          Hai gia un account? <Link to="/login">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
